import { Permission as P } from 'common/models/Permissions';

export interface ActionPermissionRow {
  module: string;
  access: P | null;
  addEdit: P | null;
  delete: P | null;
  export: P | null;
  reports: P | null;
  description?: string | null;
}
export const ActionPermissionsGridRows: ActionPermissionRow[] = [
  {
    module: 'Activities',
    access: P.Activities,
    addEdit: null,
    delete: P.ActivitiesDelete,
    export: null,
    reports: null,
  },
  {
    module: 'Adverts',
    access: P.Adverts,
    addEdit: P.AdvertsAddEdit,
    delete: P.AdvertsDelete,
    export: P.AdvertsExport,
    reports: P.AdvertsReports,
  },
  {
    module: 'Dashboard',
    access: P.Dashboard,
    addEdit: null,
    delete: null,
    export: null,
    reports: null,
  },
  {
    module: 'Documents',
    access: null,
    addEdit: P.Documents,
    delete: P.DocumentsDelete,
    export: null,
    reports: null,
  },
  {
    module: 'Candidates',
    access: P.Candidates,
    addEdit: P.CandidatesAddEdit,
    delete: P.CandidatesDelete,
    export: P.CandidatesExport,
    reports: P.CandidatesReports,
  },
  {
    module: 'Clients',
    access: P.Clients,
    addEdit: P.ClientsAddEdit,
    delete: P.ClientsDelete,
    export: P.ClientsExport,
    reports: P.ClientsReports,
  },
  {
    module: 'Contacts',
    access: P.Contacts,
    addEdit: P.ContactsAddEdit,
    delete: P.ContactsDelete,
    export: P.ContactsExport,
    reports: P.ContactsReports,
  },
  {
    module: 'Jobs',
    access: P.Jobs,
    addEdit: P.JobsAddEdit,
    delete: P.JobsDelete,
    export: P.JobsExport,
    reports: P.JobsReports,
  },
  {
    module: 'Misc',
    access: null,
    addEdit: null,
    delete: null,
    export: P.MiscExport,
    reports: P.MiscReports,
  },
  {
    module: 'Opportunities',
    access: P.Opportunities,
    addEdit: P.OpportunitiesAddEdit,
    delete: P.OpportunitiesDelete,
    export: P.OpportunitiesExport,
    reports: P.OpportunitiesReports,
  },
  {
    module: 'Placements',
    access: P.Placements,
    addEdit: P.PlacementsAddEdit,
    delete: P.PlacementsDelete,
    export: P.PlacementsExport,
    reports: P.PlacementsReports,
  },
  {
    module: 'Global Administrator',
    access: P.GlobalAdministrator,
    addEdit: null,
    delete: null,
    export: null,
    reports: null,
    description:
      'Gives complete access to all Recruit Wizard Settings - Only available to Internal Recruit Wizard staff',
  },
  {
    module: 'System Administrator',
    access: P.SystemAdministrator,
    addEdit: null,
    delete: null,
    export: null,
    reports: null,
    description: 'Gives access to all customer controllable Recruit Wizard Settings',
  },
  {
    module: 'Office Administrator',
    access: P.OfficeAdministrator,
    addEdit: null,
    delete: null,
    export: null,
    reports: null,
    description:
      'Gives limited access to Recruit Wizard Settings - User Management, SMS Credits & Integrations',
  },
  {
    module: 'Templates Administrator',
    access: P.TemplatesAdministrator,
    addEdit: null,
    delete: null,
    export: null,
    reports: null,
    description: 'Access to edit ALL templates regardless of owner',
  },
  {
    module: 'Financial Controller',
    access: P.FinancialController,
    addEdit: null,
    delete: null,
    export: null,
    reports: null,
    description: 'Access to manage Billing Groups & Placement approvals',
  },
  {
    module: 'Document Generation',
    access: P.DocumentTemplates,
    addEdit: null,
    delete: null,
    export: null,
    reports: null,
    description: 'Allows generation of documents from document templates',
  },
  {
    module: 'Electronic Signing',
    access: P.ElectronicSigning,
    addEdit: null,
    delete: null,
    export: null,
    reports: null,
    description: 'Allows sending of documents via Electronic Signing',
  },
  {
    module: 'Send Email',
    access: P.MessageCentre,
    addEdit: null,
    delete: null,
    export: null,
    reports: null,
    description: 'Allows sending of emails to contacts and candidates',
  },
  {
    module: 'Send SMS',
    access: P.MessageCentreSms,
    addEdit: null,
    delete: null,
    export: null,
    reports: null,
    description: 'Allows sending of SMS to contacts and candidates',
  },
];
